module.exports = __webpack_public_path__ + "static/media/FEI logo copy.869205f1.png";